import React from 'react';

export default () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.3125 0V3.75L0 3.75V0L10.3125 0ZM6.5625 11.25L6.5625 15L0 15L0 11.25L6.5625 11.25ZM15 5.625V9.375L0 9.375V5.625L15 5.625Z" fill="currentColor" />
  </svg>

);
